export const updateDripProcessed = state => state.updateDripProcessed;
export const updateDripProcessedSuccess = state => state.updateDripProcessedSuccess;
export const updateDripProcessedError = state => state.updateDripProcessedError;

export const sendSupportMailProcessed = state => state.sendSupportMailProcessed;
export const sendSupportMailProcessedSuccess = state => state.sendSupportMailProcessedSuccess;
export const sendSupportMailProcessedError = state => state.sendSupportMailProcessedError;
